import {getRouteApi} from "@tanstack/react-router";

export const clientNotesRouteApi = getRouteApi("/_app/sales/clients/$clientId/notes/");
